var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9052 16.7746L14.4505 16.5725C14.3494 16.5219 14.2231 16.5472 14.1221 16.623C13.6421 17.0525 13.2126 17.2546 12.8842 17.3556C12.581 17.4567 12.3031 17.1788 12.3789 16.8756L14.2736 9.8272C14.2989 9.70088 14.2989 9.5493 14.2231 9.44825C14.1221 9.29667 13.9705 9.19562 13.7936 9.19562C13.7684 9.19562 13.7431 9.19562 13.7178 9.19562L9.95364 9.8272C9.70101 9.87772 9.52416 10.1051 9.54943 10.383L9.59995 10.7872C9.62522 11.0146 9.82732 11.1914 10.08 11.1914H10.7368L8.99364 17.5577C8.99364 17.5577 8.99364 17.5577 8.99364 17.583C8.94311 17.8609 8.91785 18.2904 9.14522 18.7198C9.57469 19.5282 10.3831 19.6798 11.2168 19.6798C13.3136 19.6798 14.6021 18.0377 15.0315 17.1535C15.1326 17.0272 15.0568 16.8504 14.9052 16.7746Z",
    fill: "#003FB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1621 8.31172C14.2485 8.31172 15.1327 7.42751 15.1327 6.34119C15.1327 5.25488 14.2485 4.37067 13.1621 4.37067C12.0758 4.37067 11.1916 5.25488 11.1916 6.34119C11.1916 7.42751 12.0758 8.31172 13.1621 8.31172Z",
    fill: "#003FB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38105 0 0 5.38105 0 12C0 18.6189 5.38105 24 12 24C18.6189 24 24 18.6189 24 12C24 5.38105 18.6189 0 12 0ZM12 22.2063C6.36632 22.2063 1.79368 17.6337 1.79368 12C1.79368 6.36632 6.36632 1.79368 12 1.79368C17.6337 1.79368 22.2063 6.36632 22.2063 12C22.2063 17.6337 17.6337 22.2063 12 22.2063Z",
    fill: "#003FB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/i-icon.22b9d210c4b334dab83e1114668a7377.svg";
export { ForwardRef as ReactComponent };